import React, {useMemo} from 'react';
import Chart from 'react-apexcharts';
// import {shortenLargeNumbers} from '../helpers/shortenLargeNumbers';
import {SkeletonLoader} from './index';

function VerificationAnalyticsPieChart({verifications = {}, isLoading}) {
  const {Completed, Failed, Abandoned, Pending, Ongoing} = verifications || {};

  const series = useMemo(
    () => [
      Completed || 0,
      Failed || 0,
      Abandoned || 0,
      (Pending || 0) + (Ongoing || 0),
    ],
    [Abandoned, Completed, Failed, Ongoing, Pending],
  );

  const TOTAL_VERIFICATIONS = useMemo(
    () => series.reduce((sum, value) => +(sum + (+value || 0)), 0),
    [series],
  );

  const isEmpty = !isLoading && TOTAL_VERIFICATIONS === 0;

  const chartSeries = isEmpty ? [1] : series;

  const chartOptions = {
    labels: isEmpty
      ? ['']
      : ['Successful', 'Failed', 'Abandoned', 'In Progress'],
    colors: isEmpty
      ? ['#E9ECEF']
      : ['#87D4DB', '#F15D5F', '#2A5392', '#73739B'],
    dataLabels: {
      enabled: false,
    },
    legend: false,
    stroke: {
      show: true,
      width: 3,
      colors: ['#FFFFFF'],
    },
    plotOptions: {
      pie: {
        donut: {
          size: '91%',
        },
      },
    },
    tooltip: {
      enabled: !isEmpty,
    },
    chart: {
      width: 250,
      height: 250,
      animations: {
        enabled: true,
        easing: 'easeout',
        speed: 800,
      },
    },
    states: {
      hover: {
        filter: {
          type: 'none',
        },
      },
    },
  };

  const formatNumber = num => {
    const maxNumber = 1000;
    const wholeNumber = Math.floor(num / 1000) * 1000;
    return num > maxNumber && num > wholeNumber ? '+' : '';
  };

  return (
    <div className="relative flex justify-center items-center">
      {isLoading ? (
        <SkeletonLoader
          style={{
            width: 150,
            height: 150,
            borderRadius: '100%',
          }}
          className="before:h-[200px] !mb-0 !ml-0 !mt-3"
        />
      ) : (
        <Chart
          type="donut"
          options={chartOptions}
          series={chartSeries}
          height={200}
        />
      )}
      <div className="absolute flex flex-col items-center w-fit">
        {!isLoading && (
          <>
            <span className="text-[6px] mb-1 xl:text-sm font-normal text-[#858DAA]">
              Verifications
            </span>
            <h1 className="font-semibold text-base xl:text-[36px] text-deepBlue">
              {new Intl.NumberFormat('en-US', {
                notation: 'compact',
                compactDisplay: 'short',
                maximumFractionDigits: 1,
              }).format(TOTAL_VERIFICATIONS)}

              <span className="font-normal text-grey-500 text-xl">
                {formatNumber(TOTAL_VERIFICATIONS)}
              </span>
            </h1>{' '}
          </>
        )}
      </div>
    </div>
  );
}

export default VerificationAnalyticsPieChart;
